module.exports = __webpack_public_path__ + "static/media/HKGroteskPro-SemiBold.3c30b223.woff";